import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import * as Types from "./types";

export const employeeBenefitInKindListService = (params: {
  employeeId?: number;
  workLevelId?: number;
  compensationId?: string;
  amount?: number;
  status?: number;
}) =>
  RestAPIClient.call<RestAPIResponseList<Types.EmployeeBenefitInKind>>({
    method: HTTPRequestMethods.GET,
    url: Paths.List,
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const employeeBenefitInKindCreateService = (params: {
  employeeId: number;
  workLevelId: number;
  benefitInKindId: string;
  compensationId: string;
  reason: string;
  effectiveFrom: string;
  applicablePeriods: string[];
}) =>
  RestAPIClient.call<Types.EmployeeBenefitInKind>({
    method: HTTPRequestMethods.POST,
    url: Paths.Create,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const employeeBenefitInKindUpdateService = (params: {
  id: string;
  status?: number;
  effectiveFrom?: string;
  effectiveTo?: string;
  amount?: number;
  applicablePeriods?: {
    periodId: string;
    period: number;
    from: number;
    to: number;
    isApply: boolean;
  }[];
}) =>
  RestAPIClient.call<Types.EmployeeBenefitInKind>({
    method: HTTPRequestMethods.PUT,
    url: `${Paths.Update}/${params.id}`,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const employeeBenefitInKindDeleteService = (id: string) =>
  RestAPIClient.call<Types.EmployeeBenefitInKind>({
    method: HTTPRequestMethods.DELETE,
    url: `${Paths.Update}/${id}`,
    config: {
      requireAuthentication: true,
    },
  });

export const employeeBenefitInKindDetailService = (id: string) =>
  RestAPIClient.call<Types.EmployeeBenefitInKind>({
    method: HTTPRequestMethods.GET,
    url: `${Paths.Update}/${id}`,
    config: {
      requireAuthentication: true,
    },
  });
